import { GetAppData } from '../../../core/core';

export const BSLPayTypes = {
  alipay: 'alipay', // 支付宝
  antinstal: 'antinstal', // 花呗分期
  weixin: 'weixin', // 微信
  weixinzhuhai: 'weixinzhuhai_wap_ums', // 微信(珠海主体)
  weixingov: 'weixingov', // 微信国补收银台
  alipaygov: 'alipaygov', // 支付宝国补收银台
  micash: 'micash', // 小米钱包weixin_app
  cloud: 'cloud_quickpass', // 云闪付
  cloudzhuhai: 'cloudzhuhai_quickpass_ums', // 云商云闪付(珠海主体)
  cloudsichuan: 'cloudsichuan_quickpass_ums', // 云商云闪付(珠海主体)
  cloudtianjin: 'cloudtianjin_quickpass_ums', // 云商云闪付(天津主体)
  ypvpay: 'ypvpay', // st环境虚拟支付 app不需要支持
  miinstal: 'miinstal', // 小米分期
  creditcardinstal: 'creditcardinstal', // 新用卡分期
  unionmipay: 'unionmipay', // mipay
  baitiao: 'baitiao', // 京东白条
  bestpay: 'bestpay', // 翼支付
  applepay: 'applepay', // 苹果支付
  digital: 'digital_currency', // 数字人民币
  UPQUICKPASS: 'UPQUICKPASS', // 云闪付分期
  installmentsPay: 'more_instal', // 分期支付，埋点用
};
export const BSLPayName = {
  alipay: '支付宝', // 支付宝
  antinstal: '花呗分期', // 花呗分期
  weixin: '微信', // 微信
  micash: '小米钱包', // 小米钱包weixin_app
  cloud: '云闪付', // 云闪付
  ypvpay: 'ypvpay', // st环境虚拟支付 app不需要支持
  miinstal: '小米分期', // 小米分期
  creditcardinstal: '信用卡分期', // 新用卡分期
  unionmipay: 'mi Pay', // mipay
  baitiao: '京东白条', // 京东白条
  bestpay: '翼支付', // 翼支付
  applepay: '苹果支付', // 苹果支付
  digital: '数字人民币', // 数字人民币
};

const Platforms = {
  android: 'android',
  ios: 'ios',
  pc: 'pc',
  m: 'm',
  wxlite: 'wxlite', // 微信小程序
  ttlite: 'ttlite', // 头条小程序
  dylite: 'dylite', // 抖音小程序
  hybird: 'hybird', // 快应用
  miui: 'miui',
  yylite: 'yylite', // 有鱼小程序
};

const PlatformsMap = {
  // 各端返回getBslPlat函数返回字段的统一映射
  android: Platforms.android,
  ios: Platforms.ios,
  pc: Platforms.pc,
  m: Platforms.m,
  wxlite: Platforms.wxlite, // 微信小程序
  ttlite: Platforms.ttlite, // 头条小程序
  dylite: Platforms.dylite, // 抖音小程序
  miuilite: Platforms.hybird,
  miui: Platforms.miui,
  yylite: Platforms.yylite,
};

const BankStringConfig = {
  alipay: {
    android: 'alipay_app',
    ios: 'alipay_app',
    pc: 'alipay',
    wxlite: '',
    ttlite: 'toutiao_alipay',
    m: 'alipay_wap',
    dylite: 'toutiao_alipay', // 抖音小程序
    hybird: '', // 快应用
    miui: '',
    yylite: '',
  },
  weixin: {
    // 微信
    android: 'weixin_app',
    ios: 'weixin_app',
    pc: 'weixin_native',
    wxlite: 'weixin_little',
    ttlite: '',
    m: 'weixin_wap',
    dylite: '', // 抖音小程序
    hybird: '', // 快应用
    miui: '',
    yylite: '',
  },
  weixinzhuhai: {
    // 微信
    android: 'weixinzhuhai_wap_ums',
    ios: 'weixinzhuhai_wap_ums',
    pc: '',
    wxlite: '',
    ttlite: '',
    m: '',
    dylite: '', // 抖音小程序
    hybird: '', // 快应用
    miui: '',
    yylite: '',
  },
  antinstal: {
    // 花呗分期
    android: 'antinstal',
    ios: 'antinstal',
    pc: '',
    wxlite: '',
    ttlite: '',
    m: 'antinstal',
    dylite: '', // 抖音小程序
    hybird: '', // 快应用
    miui: '',
    yylite: '',
  },
  micash: {
    android: 'micash_app',
    ios: 'micash_wap', // 因为iOS不支持钱包SDK，所以就用micash_wap了
    pc: 'micash_wap',
    wxlite: '',
    ttlite: '',
    m: 'micash_wap',
    dylite: '', // 抖音小程序
    hybird: '', // 快应用
    miui: '',
    yylite: '',
  },
  unionmipay: {
    android: 'unionmipay',
    ios: '',
    pc: '',
    wxlite: '',
    ttlite: '',
    m: '',
    dylite: '', // 抖音小程序
    hybird: '', // 快应用
    miui: '',
    yylite: '',
  },
  ypvpay: {
    android: 'ypvpay',
    ios: 'ypvpay',
    pc: 'ypvpay',
    wxlite: 'ypvpay',
    ttlite: 'ypvpay',
    m: 'ypvpay',
    dylite: 'ypvpay', // 抖音小程序
    hybird: 'ypvpay', // 快应用
    miui: 'ypvpay',
    yylite: 'ypvpay',
  },
  miinstal: {
    android: 'miinstal_app',
    ios: 'miinstal_wap',
    pc: 'miinstal_wap',
    wxlite: '',
    ttlite: '',
    m: 'miinstal_wap',
    dylite: '', // 抖音小程序
    hybird: '', // 快应用
    miui: '',
    yylite: '',
  }, // 小米分期
  creditcardinstal: {
    android: 'creditcardinstal_app',
    ios: 'creditcardinstal_wap',
    pc: 'creditcardinstal_wap',
    wxlite: '',
    ttlite: '',
    m: 'creditcardinstal_wap',
    dylite: '', // 抖音小程序
    hybird: '', // 快应用
    miui: '',
    yylite: '',
  }, // 新用卡分期
  cloud: {
    android: 'cloud_quickpass',
    ios: 'cloud_quickpass',
    pc: '',
    wxlite: '',
    ttlite: '',
    m: '',
    dylite: '', // 抖音小程序
    hybird: '', // 快应用
    miui: '',
    yylite: '',
  },
  cloudzhuhai: {
    android: 'cloudzhuhai_quickpass_ums',
    ios: 'cloudzhuhai_quickpass_ums',
    pc: '',
    wxlite: '',
    ttlite: '',
    m: '',
    dylite: '', // 抖音小程序
    hybird: '', // 快应用
    miui: '',
    yylite: '',
  },
  cloudsichuan: {
    android: 'cloudsichuan_quickpass_ums',
    ios: 'cloudsichuan_quickpass_ums',
    pc: '',
    wxlite: '',
    ttlite: '',
    m: '',
    dylite: '', // 抖音小程序
    hybird: '', // 快应用
    miui: '',
    yylite: '',
  },
  cloudtianjin: {
    android: 'cloudtianjin_quickpass_ums',
    ios: 'cloudtianjin_quickpass_ums',
    pc: '',
    wxlite: '',
    ttlite: '',
    m: '',
    dylite: '', // 抖音小程序
    hybird: '', // 快应用
    miui: '',
    yylite: '',
  },
  baitiao: {
    android: 'baitiao_wap',
    ios: 'baitiao_wap',
    pc: '',
    wxlite: '',
    ttlite: '',
    m: 'baitiao_wap',
    dylite: '', // 抖音小程序
    hybird: '', // 快应用
    miui: '',
    yylite: '',
  },
  bestpay: {
    // 翼支付
    android: 'bestpay_app',
    ios: 'bestpay_app',
    pc: '',
    wxlite: '',
    ttlite: '',
    m: 'bestpay_wap',
    dylite: '', // 抖音小程序
    hybird: '', // 快应用
    miui: '',
    yylite: '',
  },
  applepay: {
    // 苹果支付
    android: '',
    ios: 'applepay',
    pc: '',
    wxlite: '',
    ttlite: '',
    m: '',
    dylite: '', // 抖音小程序
    hybird: '', // 快应用
    miui: '',
    yylite: '',
  },
  digital: {
    // 数字人民币支付
    android: 'digital_currency_app',
    ios: 'digital_currency_wap',
    pc: '',
    wxlite: '',
    ttlite: '',
    m: 'digital_currency_wap',
    dylite: '', // 抖音小程序
    hybird: '', // 快应用
    miui: '',
    yylite: '',
  },
  UPQUICKPASS: {
    // 云闪付分期
    android: 'UPQUICKPASS',
    ios: 'UPQUICKPASS',
    pc: '',
    wxlite: '',
    ttlite: '',
    m: '',
    dylite: '', // 抖音小程序
    hybird: '', // 快应用
    miui: '',
    yylite: '',
  },
  alipaygov: {
    // 支付宝
    android: 'alipaygov',
    ios: 'alipaygov',
    pc: '',
    wxlite: '',
    ttlite: '',
    m: '',
    dylite: '', // 抖音小程序
    hybird: '', // 快应用
    miui: '',
    yylite: '',
  },
  weixingov: {
    android: 'weixingov',
    ios: 'weixingov',
    pc: '',
    wxlite: '',
    ttlite: '',
    m: '',
    dylite: '', // 抖音小程序
    hybird: '', // 快应用
    miui: '',
    yylite: '',
  },
};

export function getBankTypeString(payType) {
  const platform = PlatformsMap[GetAppData().getBslPlatForPay()];
  return BankStringConfig?.[payType]?.[platform] || '';
}
